module.exports = __webpack_public_path__ + "img/logo_emara3.8a6463cb.png";